import type { FC } from "react";
import React from "react";

import { Counter } from "../../../../Counter/Counter";

import type { PickOfUnion } from "../../../../../types/react";
import type { CounterProps } from "../../../../Counter/Counter";

const AVATAR_COUNTER_TEST_ID = "avatar-counter-test-id";

type AvatarCounterMainProps = PickOfUnion<CounterProps, "quantity">;

export const AvatarCounter: FC<AvatarCounterMainProps> = (props) => {
    return (
        <Counter
            {...(props as CounterProps)}
            stroke
            data-tsid={AVATAR_COUNTER_TEST_ID}
        />
    );
};

AvatarCounter.displayName = "Avatar.Counter";

export default AvatarCounter;
